import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from './api/forgotPassword';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage('Please enter your email address');
      setIsSuccess(false);
      return;
    }

    setIsLoading(true);
    setMessage('');

    try {
      await forgotPassword(email);
      setMessage('Password reset link has been sent to your email address');
      setIsSuccess(true);
      setEmail('');
    } catch (error) {
      setMessage(error.message || 'Failed to send reset link. Please try again.');
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#f8f9fa', overflow: 'hidden' }}>
      <div className="container-fluid px-3">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-4">
            {/* Logo */}
            <div className="text-center mb-4">
              <img src="./static/logo.png" width={160} alt="Logo" />
            </div>
            {/* Form Card */}
            <div className="card shadow-sm" style={{ borderRadius: '6px', maxWidth: '100%' }}>
              <div className="card-body p-4">
                <h2 className="card-title mb-3 fw-bold">Forgot Password</h2>

                <p className="text-muted mb-4">
                  Enter your email address and we'll send you a link to reset your password.
                </p>

                {message && (
                  <div className={`alert ${isSuccess ? 'alert-success' : 'alert-danger'} mb-3`}>
                    {message}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label fw-semibold">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{ borderRadius: '8px' }}
                      disabled={isLoading}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn w-100 fw-semibold btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      'Send'
                    )}
                  </button>
                </form>

                <div className="text-center mt-4">
                  <span className="text-muted">Remember your password? </span>
                  <Link
                    to="/login"
                    className="text-decoration-none fw-semibold"
                  >
                    Sign in
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 